import { logEvent } from "firebase/analytics";

export const firstLaunchEvent = (analytics, dataObj) => {
  logEvent(analytics, "first_launch", dataObj);
};

export const appOpenEvent = (analytics, dataObj) => {
  logEvent(analytics, "app_open", dataObj);
};

export const landingOpenEvent = (analytics, dataObj) => {
  logEvent(analytics, "landing_open", dataObj);
};

export const landingCompleteEvent = (analytics, dataObj) => {
  logEvent(analytics, "landing_complete", dataObj);
};

export const onboardingStartEvent = (analytics, dataObj) => {
  logEvent(analytics, "onboarding_start", dataObj);
};

export const onboardingFillEvent = (analytics, dataObj) => {
  logEvent(analytics, "onboarding_fill", dataObj);
};

export const onboardingCompleteEvent = (analytics, dataObj) => {
  logEvent(analytics, "onboarding_complete", dataObj);
};

export const personalSleepPlanGenerateEvent = (analytics, dataObj) => {
  logEvent(analytics, "personal_sleep_plan_generate", dataObj);
};

export const storeOpenEvent = (analytics, dataObj) => {
  logEvent(analytics, "store_open", dataObj);
};

export const loadGenerateEvent = (analytics, dataObj) => {
  logEvent(analytics, "lead_generate", dataObj);
};

export const paywallOpenEvent = (analytics, dataObj) => {
  logEvent(analytics, "paywall_open", dataObj);
};

export const paymentTypeEvent = (analytics, dataObj) => {
  logEvent(analytics, "paymentmethod_change", dataObj);
};

export const paymentInfoAddEvent = (analytics, dataObj) => {
  logEvent(analytics, "paymentinfo_add", dataObj);
};

export const checkoutInitiateEvent = (analytics, dataObj) => {
  logEvent(analytics, "checkout_initiate", dataObj);
};

export const trialStartEvent = (analytics, dataObj) => {
  logEvent(analytics, "trial_start", dataObj);
};

export const revenueFirebase = (
  productId,
  paymentId,
  price,
  analytics,
  dataObj
) => {
  const params10 = {
    transaction_id: paymentId,
    affiliation: productId,
    currency: "USD",
    value: price, // Total Revenue
    ...dataObj,
  };
  logEvent(analytics, "trial_start", params10);
};
